<template>
  <v-container class="grey lighten-5">
    <v-breadcrumbs :items="breadCrumbs">
      <template v-slot:item="{ item }">
        <v-breadcrumbs-item @click="clickBreadCrumb(item.text)" :disabled="item.disabled" :link="true">
          {{ item.text }}
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>
    <div v-if="selectedCourse === null">
      <h2>Kursverwaltung</h2>
      <br/>
      <v-data-table
          :headers="standardHeaders"
          :items="courses"
          :search="search"
          :items-per-page="15"
          class="elevation-1"
      >
        <template v-slot:top>
          <v-text-field
              append-icon="mdi-magnify"
              v-model="search"
              single-line
              label="Suche"
              class="mx-4"
          />
        </template>

        <template v-slot:item.isLocked="{ item }">
          <v-simple-checkbox
              v-model="item.isLocked"
              disabled
          />
        </template>

        <template v-slot:item.edit="{ item }">
          <v-btn
              @click="openEdit(item)"
              class="ma-2"
              outlined
              x-small
              fab
              color="indigo"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>

      </v-data-table>

      <v-btn class="ma-1" color="info" @click="createCourse">
        Schulung erstellen
        <template v-slot:loader>
        <span class="custom-loader">
          <v-icon light>mdi-cached</v-icon>
        </span>
        </template>
      </v-btn>
    </div>
    <div v-else>
      <v-btn
          @click="selectedCourse = null"
          class="ma-2"
          outlined
          x-small
          color="indigo"
      >
        Zurück
      </v-btn>
      <CourseEdit :course-id="selectedCourse.id" @finish="onCreated" @deleted="onDeleted"/>
    </div>
  </v-container>

</template>

<script>

import CourseEdit from "@/components/CourseEdit";
import Course from "@/models/Course";

export default {
  name: "SuperAdminCourseSettings",
  components: {CourseEdit},
  data: () => ({
    selectedCourse: null,
    courses: [],
    search: '',
    standardHeaders: [
      {
        text: "Titel",
        value: "title",
      },
      {text: "Deaktiviert", value: "isLocked"},
      {
        text: "Ändern", value: "edit",
        sortable: false,
      },
    ]
  }),
  computed: {
    breadCrumbs() {
      if (this.selectedCourse === null) {
        return [{
          text: "Schulungen", disabled: true
        }]
      } else {
        return [{
          text: "Schulungen", disabled: false, link: true
        }, {
          text: this.selectedCourse.title, disabled: true
        }]
      }
    }
  },
  methods: {
    onCreated(item) {
      this.courses.unshift(item);
      this.selectedCourse = null;
    },
    onDeleted() {
      this.selectedCourse = null;
      this.loadData();
    },
    clickBreadCrumb(text) {
      if (this.selectedCourse && text === "Schulungen") {
        this.selectedCourse = null;
        this.loadData();
      }
    },
    createCourse() {
      this.selectedCourse = new Course({});
    },
    openEdit(item) {
      this.selectedCourse = item;
    },
    loadData() {
      this.$httpCourseApi.getAll((result) => {
        this.courses = result;
      })
    },
  },
  mounted() {
    this.loadData();
  }
}
</script>

<style scoped>

</style>
